export default {
  getDependenciesMsg (data) {
    let dependencies = []
    dependencies.push('Los siguientes Usuarios poseen dependencia con esta Entidad Comercial.')
    dependencies.push(' ')
    dependencies.push(...data)
    dependencies.push(' ')
    dependencies.push(' ')
    dependencies.push('Por favor, elimine las dependencias y vuelva a intentarlo.')
    return dependencies
  },
  filterCompanies (companies, filters) {
    let filteringEntity = companies
    const {name, responsibleType, cuit} = filters
    if (name) {
      filteringEntity = filteringEntity.filter((i) => {
        return !(i.name.search(new RegExp(name, 'i')) < 0)
      })
    }
    if (responsibleType) {
      filteringEntity = filteringEntity.filter((i) => {
        return (i.responsibleType.description.includes(responsibleType))
      })
    }
    if (cuit) {
      filteringEntity = filteringEntity.filter((i) => {
        return !(i.cuit.search(new RegExp(cuit, 'i')) < 0)
      })
    }
    return filteringEntity
  }
}
